export const initialAdminDateRange = 7;
